// transportTypePage.jsx
import { useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import { LoadingContext, M_StateActions, NavigateContext } from 'src/M_Components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import TransportTypeConfig from './transportTypeConfig';
import TransportTypeConfigCrud from './transportTypeConfigCrud';

export default function TransportTypePage({ roles, onCreateTab, toastMessages, handleTabClose }) {
    const ctx = useContext(LoadingContext);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const matches = useMediaQuery('(min-width:900px)');
    const M_State = useSelector((state) => state.StateKeyValue);
    const location = useLocation();
    const { renameTab } = useContext(NavigateContext);
    const selectedTab = useSelector(s => s.StateKeyValue.find(o => o.key === 'selectedTab')?.value);


    const [menu, setMenu] = useState(1);
    const [selectedTransportType, setSelectedTransportType] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [id, setId] = useState(() => M_State.find(obj => obj.key === 'selectedTab')?.value || 'transportType'); // Default to 'transportType' if not found

    //============================================================================================================
    // Session keys for restoring tab state
    //============================================================================================================
    const sessionKeys =
        [
            'menu',
            'selectedTransportType',
            'refresh'
        ]; // Keys to store in session storage

    //============================================================================================================
    // EFFECT
    //  Rename tab on language change or selectedTab change
    //============================================================================================================
    useEffect(() => {
        if (!selectedTab) return; // If no selectedTab, do nothing
        renameTab(String(selectedTab), t('TransportTypes')); // Rename the tab with the translated title
    }, [selectedTab, t]);


    //============================================================================================================
    // EFFECT
    // Effect to restore session state on mount
    //============================================================================================================
    useEffect(() => {
        const session = M_State.find(obj => obj.key === id)?.value; // Retrieve session data for the current tab
        if (session) { // Check if session data exists
            const m = session.find(x => x.key === 'menu')?.value; // Get menu value from session
            const line = session.find(x => x.key === 'selectedTransportType')?.value; // Get selected transport type from session
            const ref = session.find(x => x.key === 'refresh')?.value; // Get refresh value from session
            if (m) setMenu(m); // Set menu state from session
            if (line) setSelectedTransportType(line); // Set selected transport type from session
            if (ref !== undefined) setRefresh(ref); // Set refresh state from session
        }
        setRefresh(r => !r); // Trigger a refresh to ensure the latest data is loaded
    }, [location.pathname]);

    //============================================================================================================
    // EFFECT
    // Effect to update session storage when menu, selectedTransportType, or refresh changes
    //============================================================================================================
    useEffect(() => {
        const sessionData = [ // Prepare session data to store
            { key: 'menu', value: menu },
            { key: 'selectedTransportType', value: selectedTransportType },
            { key: 'refresh', value: refresh }
        ];
        dispatch(M_StateActions.addM_State({ key: id, value: sessionData })); // Update Redux state with new session data
    }, [id, menu, selectedTransportType, refresh]);

    return (
        <div className="divGlobalSettings">
            <div style={matches ? { display: 'flex' } : {}}>
                <div className="settingsPageMainDiv">
                    <Routes>
                        <Route index element={
                            <TransportTypeConfig // Main transport type configuration component with dynamic table
                                roles={roles}
                                onCreateTab={onCreateTab}
                                toastMessages={toastMessages}
                                selectedTransportType={selectedTransportType}
                                setSelectedTransportType={setSelectedTransportType}
                                refresh={refresh}
                                setRefresh={setRefresh}
                            />
                        } />
                        <Route path='transportTypeConfigCrud' element={
                            <TransportTypeConfigCrud // Component for creating and editing and viewing transport types
                                handleTabClose={handleTabClose}
                                toastMessages={toastMessages}
                            />
                        } />
                    </Routes>
                </div>
            </div>
        </div>
    );
}
